(function($) {

    'use strict';

    var init = function() {
        var button = $('.flexTab__wrapper');
        button.on('click', toggleTab);
    };

    var toggleTab = function() {
        var tab = $('#' + $(this).data('switch'))
        if($(this).hasClass('active')) {
            $(this).removeClass('active')
            tab.slideUp(300)
        } else {
            $(this).addClass('active')
            tab.slideToggle(300)
        }
    }

    $(document).ready(function() {
        init(); 
    });

})(jQuery);
